import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { useEffect, useState } from "react";

import RouteConfig from './RouteConfig';
import RefreshDialogBox from './components/Common/RefreshDialog/RefreshDialogBox';
import { registerSessionDialogCallback } from './components/Common/RefreshDialog/SessionDialougeTrigger';
function App() {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    registerSessionDialogCallback(() => {
      setShowDialog(true);
    });
  }, []);

  return (
    <>
      <RouteConfig />
      {showDialog && <RefreshDialogBox onClose={() => setShowDialog(false)} open={true}/>}
    </>
  );
}

export default App;
